import { ACTIVITIES_BASE_HEIGHT_LARGE } from 'global/constants';
import { COLOURS } from './response.constants';
import { AnswerFragment_answer } from 'approot/activity-builder/present/__generated__/AnswerFragment';
import { isRichtextValueEmpty } from '../shared/logic/get-richtext-value';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';

export function getFieldHeight(size: number, baseHeight?: number | null) {
  return size * (baseHeight || ACTIVITIES_BASE_HEIGHT_LARGE);
}

export function getBackgroundColour(baseColour: string) {
  return COLOURS.find(c => c.base === baseColour)?.colour1;
}

export function getBorderColour(baseColour: string) {
  return COLOURS.find(c => c.base === baseColour)?.colour2;
}

export function getAnswerCount(
  answers: {
    uuid: string;
    studentId: number | null;
    answer: AnswerFragment_answer | null;
  }[]
) {
  const studentsWithResponses = new Set();

  answers.forEach(a => {
    if (!isRichtextValueEmpty(getRichtextAnswer(a))) {
      studentsWithResponses.add(a.studentId);
    }
  });

  return studentsWithResponses.size;
}
